import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Input({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-851" data-mp="zlgllqryvsum">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-852" data-mp="zmhvhrx8y9ar">
          {label}
        </label>}
      <div className="relative" data-id="element-853" data-mp="19iupkqwpep61">
        {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-854" data-mp="19hs2yv6ez8vx">
            {leftIcon}
          </div>}
        <input id={inputId} className={`
            w-full px-4 py-2.5 rounded-lg border transition-all duration-200
            ${leftIcon ? 'pl-10' : ''}
            ${rightIcon ? 'pr-10' : ''}
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200'}
            placeholder:text-gray-400
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined} {...props} data-id="element-855" data-mp="1dlrdmx50jdhd" />
        {rightIcon && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-856" data-mp="234ir87p7kncl">
            {rightIcon}
          </div>}
      </div>
      {error && <p id={`${inputId}-error`} className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-857" data-mp="1td4m9kehmvc2">
          {error}
        </p>}
      {helperText && !error && <p id={`${inputId}-helper`} className="mt-1.5 text-sm text-gray-500" data-id="element-858" data-mp="1ofct6n23x36a">
          {helperText}
        </p>}
    </div>;
}